import poof from '../behaviors/confetti'
import {controller, target, attr} from '@github/catalyst'

@controller
class ShowConfettiPartyElement extends HTMLElement {
  connectedCallback() {
    poof()
  }
}

@controller
class BillingDurationElement extends HTMLElement {
  @target declare yearlyRadioInput: HTMLElement
  @target declare monthlyRadioInput: HTMLElement
  @attr bgColorClass: string = 'color-bg-inset'
  @attr borderColorClass: string = 'color-border-accent'

  toggleHighlight(add: HTMLElement, remove: HTMLElement) {
    add.classList.add(this.bgColorClass, this.borderColorClass)
    remove.classList.remove(this.bgColorClass, this.borderColorClass)
  }

  select(event: Event) {
    if (event.currentTarget === this.yearlyRadioInput) {
      this.toggleHighlight(this.yearlyRadioInput, this.monthlyRadioInput)
    } else if (event.currentTarget === this.monthlyRadioInput) {
      this.toggleHighlight(this.monthlyRadioInput, this.yearlyRadioInput)
    }
  }
}
